import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MaterialModule } from 'app/material.module'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ChatbotDialogComponent } from './chatbot-dialog/chatbot-dialog.component';
import { AiCopilotComponent } from './ai-copilot/ai-copilot.component';
import { AiCardComponent } from './ai-card/ai-card.component';
import { AiScribeComponent } from './ai-scribe/ai-scribe.component';
import { AiStoreInsightsComponent } from './ai-store-insights/ai-store-insights.component';
import { AiStoreCockpitComponent } from './ai-store-cockpit/ai-store-cockpit.component';
import { EyeVisionLabComponent } from './eye-vision-lab/eye-vision-lab.component';
import { ChartsModule } from 'ng2-charts';

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http,'./assets/i18n/', '.json');
}


@NgModule({
  declarations: [ChatbotDialogComponent, AiCopilotComponent, AiCardComponent, AiScribeComponent, AiStoreInsightsComponent, AiStoreCockpitComponent, EyeVisionLabComponent],
  exports: [
    HttpClientModule,
    CommonModule,
    TranslateModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    Ng2SearchPipeModule,
    ChatbotDialogComponent,
    AiCopilotComponent,
    AiCardComponent,
    AiScribeComponent,
    AiStoreInsightsComponent,
    AiStoreCockpitComponent,
    EyeVisionLabComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
     FormsModule,
     ReactiveFormsModule,
     MaterialModule,
     MatExpansionModule,
     Ng2SearchPipeModule,
     ChartsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  
})
export class SharedModule { }
